import { createAsyncThunk } from "@reduxjs/toolkit";
import { Base_URL, ApiCall } from "../../Common/Path";

export const GetAllUsersName = createAsyncThunk("GetAllUsersName", async () => {
  try {
    const response = await ApiCall(`${Base_URL}/user/get-users-names`);
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});
export const GetUserStatusTable = createAsyncThunk(
  "GetUserStatusTable",
  async (portal) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/strategies/all-investors-by-manager/${portal}`,
        "",
        "get"
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);
export const GetUsers = createAsyncThunk("GetUsers", async (params) => {
  try {
    let url = `${Base_URL}/users/relations/${params.type}`;
    
    const response = await ApiCall(url);
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const GetTeamMembers = createAsyncThunk("GetTeamMembers", async () => {
  try {
    const response = await ApiCall(`${Base_URL}/users/relations/children`);
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const GetPermissionGroups = createAsyncThunk("GetPermissionGroups", async (groupRole = "MANAGER") => {
  try {
    const response = await ApiCall(`${Base_URL}/permissions/groups?groupRole=${groupRole}`);
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});
export const GetUserInfo = createAsyncThunk(
  "GetUserInfo",
  async () => {
    try {
      const response = await ApiCall(`${Base_URL}/users/info`);

      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const GetUserPermissions = createAsyncThunk(
  "GetUserPermissions",
  async () => {
    try {
      const response = await ApiCall(
        `${Base_URL}/permissions/available-apis`
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);
export const postUser = createAsyncThunk("postUser", async (body, { getState }) => {
  try {
    // Validate user creation permissions to prevent unauthorized privileged user creation
    const { role } = body;
        
    // Prevent creation of MANAGER role by non-managers
    if (role === 'MANAGER' ) {
      throw new Error("Only managers can create other managers");
    }
    
    // Validate required fields
    if (!body.email || !body.role) {
      throw new Error("Email and role are required");
    }
    
    let url = `${Base_URL}/users`;
    const result = await ApiCall(url, body, "post");
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});
export const postUserPermissions = createAsyncThunk(
  "postUserPermissions",
  async ({ body}) => {
    try {
      const url = `${Base_URL}/permissions`;
      const result = await ApiCall(url, body, "post");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const respondToRequests = createAsyncThunk(
  "respondToRequests",
  async (body) => {
    try {
      const url = `${Base_URL}/users/relations/respond`;
      const result = await ApiCall(url, body, "put");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);
export const GetUserPermission = createAsyncThunk(
  "GetUserPermission",
  async ({ id}) => {
    try {
      const url = `${Base_URL}/permissions/allowed-child-access?childRoleId=${id}`;
      const result = await ApiCall(url, null, "get");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const DeletetUser = createAsyncThunk(
  "DeletetUser",
  async ({id}, { rejectWithValue }) => {
    try {
      // const url = `${Base_URL}/users/child-role?childRoleId=${id}`;
      const url = `${Base_URL}/users/relations/${id}`;
      const response = await ApiCall(url, null, "delete");
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response
          ? error.response.data
          : "An error occurred while deleting the user"
      );
    }
  }
);


export const GetLogs = createAsyncThunk(
  "GetLogs",
  async ({ id }) => {
    try {
      const url = `${Base_URL}/logger/logs`;
      const result = await ApiCall(url, null, "get");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);


export const GetNotification = createAsyncThunk(
  "GetNotification",
  async ({ entityId}) => {
    try {
      const url = `${Base_URL}/notifications`;
      const result = await ApiCall(url, null, "get");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const ChangeNotificationStatus = createAsyncThunk(
  "ChangeNotificationStatus",
  async ({id, body}) => {
    try {
      const url = `${Base_URL}/notifications/${id}`;
      const result = await ApiCall(url, body, "PATCH");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const ChangeAllNotificationStatus = createAsyncThunk("ChangeAllNotificationStatus", async (type, { getState }) => {
  const {token} = getState().auth;
  const result = await ApiCall(`${Base_URL}/notifications/read-all`, "", "put", token);
  return result;
});

// export const TwoFactorSetup = createAsyncThunk("TwoFactorSetup", async (body, { getState }) => {
//   const {token} = getState().auth;
//   alert("hello")
//   const result = await ApiCall(`${Base_URL}/2fa/setup`, '', "post", token);
//   return result;
// });

export const TwoFactorSetup = createAsyncThunk(
  "TwoFactorSetup",
  async () => {
    try {
      const url = `${Base_URL}/2fa/setup`;
      const result = await ApiCall(url, null, "POST");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const EnableTwoFactor = createAsyncThunk(
  "EnableTwoFactor",
  async (body) => {
    try {
      const url = `${Base_URL}/2fa/enable`;
      const result = await ApiCall(url, body, "POST");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const DisableTwoFactor = createAsyncThunk(
  "DisableTwoFactor",
  async () => {
    try {
      const url = `${Base_URL}/2fa/disable`;
      const result = await ApiCall(url, null, "POST");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const TwoFAVerify = createAsyncThunk(
  "TwoFAVerify",
  async (body) => {
    try {
      const url = `${Base_URL}/2fa/verify`;
      const result = await ApiCall(url, body, "POST");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const UpdateUserInfo = createAsyncThunk(
  "UpdateUserInfo",
  async (body) => {
    try {
      const url = `${Base_URL}/users/user-info`;
      const result = await ApiCall(url, body, "PUT");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const UpdateEntityInfo = createAsyncThunk(
  "UpdateEntityInfo",
  async (body) => {
    try {
      const url = `${Base_URL}/users/entity-info`;
      const result = await ApiCall(url, body, "PUT");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);